import { IAdvertising } from "api/types/_advertising";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string;
}
interface DropdownAdvertisingProps {
  name?: string,
  getByKey?: string,
  dataList?: IAdvertising[],
  initialValue?: Option | Option[] | null;
  onChangeSelect?: (params: Option) => void;
  placeholder?: string,
  isMulti?: boolean,
}
const DropdownAdvertising = ({
  name = '',
  getByKey = 'id',
  initialValue,
  dataList = [],
  onChangeSelect,
  placeholder,
  isMulti = false,
}: DropdownAdvertisingProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    const result = dataList?.map((item: any) => ({
      label: item?.title || '',
      value: String(item[getByKey])
    })) || [] as Option[];
    setOptions((_prev: any) => result);
  }, [JSON.stringify(dataList), getByKey]);

  return (
    <React.Fragment>
      <Select
        cacheOptions
        options={options}
        closeMenuOnSelect={true}
        name={name}
        value={initialValue}
        isMulti={isMulti}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder ? placeholder : t('Select Inventory')}...</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        formatOptionLabel={(option: any) => (<div className="d-flex">{option?.label}</div>)}
        className="search-filter-media dropdown-status-rounded"
        classNamePrefix="name-prefix"
      />
    </React.Fragment>
  );
};

export default DropdownAdvertising;
